import { Link } from "react-router-dom";

import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

export const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.box};
  /* background-color: #673ab7; */
  box-shadow: ${({ theme }) => theme.shadow};
  width: ${({ width }) => (width ? width : "500px")};
  margin: 0.5rem 0;
  border-radius: 10px;
  padding: 2rem 0;
  margin: 1rem;
`;

export const CardIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: red;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0.5rem auto;
  background-color: ${({ color }) => color};
  color: #fff;
`;

export const CardTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
